// services/passwordService.tsx
import { axiosInstance } from "../../../api/axiosInstance.tsx";

interface PasswordUpdateData {
  currentPassword: string;
  newPassword: string;
}

export const updatePassword = async (data: PasswordUpdateData) => {
  try {
    const response = await axiosInstance.post("/auth/update-password", data);
    return response.data;
  } catch (error: any) {
    let errorMessage = "Failed to update password";

    if (error.response) {
      // Handle password policy violations
      if (
        error.response.status === 422 &&
        error.response.data?.errors?.password
      ) {
        errorMessage = error.response.data.errors.password.join(", ");
      }
      // Handle incorrect current password
      else if (error.response.status === 401) {
        errorMessage = "Current password is incorrect";
      }
    }

    throw new Error(errorMessage);
  }
};
